import API from "@/apis";
import axios from "@/libs/axios";
import router from "@/router";
import menuConfig from "@/router/menuConfig";
import { getCurrentServiceDomain } from "@/libs/common";

let UserAgent = null;

async function getLoginUser() {
    if (!UserAgent) {
        try {
            let res = await axios.get(API.GET_USER_AGENT);

            if (res.success) {
                UserAgent = res.data;
                if (!UserAgent.userType) {
                    throw new Error("用户类型缺失");
                }
                // 补充全局使用的角色信息
                UserAgent.isPlatRole =
                    ["R01", "R02"].indexOf(UserAgent.userType) > -1;
                UserAgent.isSiteRole =
                    ["R03", "R04"].indexOf(UserAgent.userType) > -1;
                UserAgent.isStoreRole =
                    ["R05", "R06"].indexOf(UserAgent.userType) > -1;
                let displayNameMap = {
                    R01: `超级管理员(${UserAgent.loginName})`,
                    R02: `平台子账号(${UserAgent.loginName})`,
                    R03: `${UserAgent.siteName}管理员(${UserAgent.loginName})`,
                    R04: `${UserAgent.siteName}子账号(${UserAgent.loginName})`,
                    R05: `${UserAgent.storeName}(${UserAgent.loginName})`,
                    R06: `${UserAgent.storeName}(${UserAgent.loginName})`
                };
                UserAgent.displayName =
                    displayNameMap[UserAgent.userType] || UserAgent.loginName;
                return UserAgent;
            } else {
                throw new Error(res.msg);
            }
        } catch (e) {
            console.log(e);
            window.alert("获取用户信息失败，请重新登录！");
            router.push({
                path: "/frontPage/login"
            });
            return null;
        }
    } else {
        return UserAgent;
    }
}

function clearLoginUser() {
    UserAgent = null;
}

async function getMenuData(curPath) {
    let menuData = [];
    let res = await axios.get(API.GET_USER_MENU);
    if (res.success) {
        let newMenu = res.data;
        let routes = router.options.routes
            .find(item => item.path === "/")
            .children.filter(item => item.path !== "/home");
        let newMenu2 = [];

        for (let i = 0; i < newMenu.length; i++) {
            let menuItem = newMenu[i];
            let topMenu = menuConfig[menuItem.path];
            if (topMenu) {
                newMenu[i] = { ...topMenu, ...newMenu[i] };
                newMenu[i].children.forEach(item => {
                    let routeItem = routes.find(
                        route => route.path === item.path
                    );
                    Object.assign(item, routeItem);
                    if (!(item.children && item.children.length)) {
                        delete item.children;
                    } else {
                        //三级菜单的处理，暂时没有
                    }
                });
                newMenu2.push(newMenu[i]);
            }
        }
        menuData = newMenu2;
    } else {
        throw new Error(res.msg);
    }

    if (!curPath) {
        return [...menuData];
    } else {
        let pathArr = genPathArray(menuData, curPath, []);
        let lastPath = null;
        if (pathArr.length > 1) {
            lastPath = pathArr.pop();
        }
        if (!(lastPath && lastPath.path === curPath)) {
            let curRoute = router.options.routes
                .find(item => item.path === "/")
                .children.find(route => route.path === curPath);
            pathArr.push({
                name: curRoute.name,
                path: curRoute.path
            });
        } else {
            pathArr.push(lastPath);
        }
        return pathArr;
    }
}

// 获得根据后台接口返回的路由层级
function genPathArray(menuData, path, pathArr) {
    if (menuData.length === 0 || path.length === 0) {
        return pathArr;
    }
    let index = menuData.findIndex(item => path.indexOf(item.path) === 0);
    if (index === -1) {
        return pathArr;
    }
    let menu = menuData[index];
    pathArr.push({ path: menu.path, name: menu.name });
    if (menu.children && menu.children.length) {
        pathArr = genPathArray(menu.children, path, pathArr);
    }
    return pathArr;
}

export { getLoginUser, clearLoginUser, getMenuData };



// WEBPACK FOOTER //
// ./src/libs/global.js